export default __webpack_public_path__ + "static/media/avatar.4bf316b6.png";